import { createSelector } from 'reselect';
import PredesTransactionsColumns from '../../containers/PredesTransactionsColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.PREDES_TRANSACTIONS.isLoading;
export const getCheckedRows = (state) => state.listing.PREDES_TRANSACTIONS.selectedRows;
export const getData = TableDefinitions.PREDES_TRANSACTIONS.getDataFunction();
export const getColumns = createSelector(getData, PredesTransactionsColumns);
